export default "__VITE_ASSET__BZqb88Sj__"